import * as React from "react";
import "./availability.sass";

interface ComponentProps {
    isDisabled: boolean;
}

// TODO: taken from paola's branch, consolidate after
const Availability: React.FunctionComponent<ComponentProps> = (props) => {
    return (
        <React.Fragment>
            {
                props.isDisabled ?
                    <span className="item-state grey">Disabled</span> :
                    <span className="item-state green">Enabled</span>
            }
        </React.Fragment>
    );
};

export default Availability;